export default {
  type: 'lookbook',
  aliases: ['lookbook'],
  path: 'Lookbook/LookbookTemplate.vue',
  slices: [{
    name: 'global_footer',
    path: 'Global/GlobalFooter.vue'
  }]
};